import Router from 'next/router'
import css from '../../static/css/banner.css'

export default class extends React.Component{

  render() {
    return(
      <div className="cover home-cover">
        <div className="container" style={{paddingTop:'120px'}}>
          <div className="row justify-content-md-center">
            <div className="col-md-5">
              <div className="slogan-container">
                <p className="slogan">
                  Unified<br/>
                 KYC<br/>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// components/kyc/Banner.js